/**
 * cdn创建资源引导页
 */
import { useEffect } from 'react';
import { FormattedMessage, getLocale } from 'umi';
import { useFomatter } from '@/hooks';
import { Button } from 'antd';
import {
  ArrowRightOutlined,
  CloseCircleFilled,
  CheckCircleFilled,
  // WarningFilled,
} from '@ant-design/icons';
import { closeStepRender } from './common';
import GuideBox from './GuideBox';
import guideImg from '@/assets/images/guide-right-img.png';
import guideLeftImg from '@/assets/images/guide-left-img.png';
const CdnCreate = (props: any) => {
  const { onClick, step = 1 } = props;
  const locale = getLocale();
  const { formatter } = useFomatter();
  useEffect(() => {
    if (step === 2 && document.getElementById('tierFollow')) {
      if (document.querySelector('.tier-box.u-hide')) {
        document.getElementById('tierFollow')?.click();
      }
    }
    if (step === 4) {
      if (!document.querySelector('.tier-box.u-hide')) {
        document.getElementById('tierFollow')?.click();
      }
    }
  }, [step]);
  //doc文档跳转
  const rulesDocLink = () => {
    const _locale = (locale || 'en-US').substring(3)?.toLowerCase();
    return `https://docs.lightcdn.com/${_locale}/CDN%20Resources/Origin%20server%20hostname.html`;
  };
  return (
    <div className={'m_cdn_create_box'}>
      {step === 1 ? (
        <>
          <div className="u-img2">
            <div className="u-guide-btnBox">
              <div className="u-left">
                <img src={guideImg} />
              </div>
              <div className="u-right">
                <GuideBox
                  title={formatter({ id: 'guide.CdnCreate.step.title1.2' })}
                  dir="bottomRight"
                  isLongLine={true}
                >
                  <div>
                    <CheckCircleFilled className="c-green" /> subexample.example.com
                  </div>
                  <div>
                    <CheckCircleFilled className="c-green" /> *.example.com
                    <span className="c-gray6">
                      <FormattedMessage id="cdnResources.create.step1.tip5" />
                    </span>
                  </div>
                </GuideBox>
                <div className="u-btn-box">
                  <Button
                    type="primary"
                    onClick={() => {
                      onClick?.('cdn_create_5');
                      document
                        .getElementById('sourceSegmented')
                        ?.scrollIntoView({ behavior: 'smooth' });
                    }}
                  >
                    <FormattedMessage id="guide.next" />
                    <ArrowRightOutlined style={{ marginLeft: 5 }} />
                  </Button>
                  {closeStepRender({ onClick })}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
      {step === 5 ? (
        <>
          <div className="u-img51">
            <div className="u-guide-btnBox">
              <div className="u-right">
                <GuideBox
                  title={formatter({ id: 'guide.CdnCreate.step.title1.1' })}
                  dir="bottomLeft"
                  isLongLine={true}
                >
                  <div>
                    <CloseCircleFilled className="c-red" /> example.com/folder
                  </div>
                  <div>
                    <CheckCircleFilled className="c-green" /> example.com
                  </div>
                  <div>
                    <CheckCircleFilled className="c-green" /> subexample.example.com
                  </div>
                  <div>
                    <CheckCircleFilled className="c-green" /> 125.125.125.125
                  </div>
                  <div>{formatter({ id: 'guide.CdnCreate.step.content5.1' })}</div>
                </GuideBox>
                <div className="u-btn-box f-tr">
                  <Button
                    type="primary"
                    onClick={() => {
                      onClick?.('cdn_create_6');
                    }}
                  >
                    <FormattedMessage id="guide.next" />
                    <ArrowRightOutlined style={{ marginLeft: 5 }} />
                  </Button>
                  {closeStepRender({ onClick })}
                </div>
              </div>
              <div className="u-left">
                <img src={guideLeftImg} />
              </div>
            </div>
          </div>
          <div className={'u-img52'}>
            <GuideBox dir="topLeft">
              <div>
                {formatter({ id: 'guide.CdnCreate.step.content5.2' })}
                <a href={rulesDocLink()} target="_blank" rel="noreferrer" className="u-underline">
                  {formatter({ id: 'guide.CdnCreate.step.content5.3' })}
                </a>
              </div>
            </GuideBox>
          </div>
        </>
      ) : null}
      {step === 6 ? (
        <>
          <div className="u-img60">
            <div className="u-guide-btnBox">
              <div className="u-left">
                <img src={guideImg} />
              </div>
              <div className="u-right">
                <div className="u-btn-box">
                  <Button
                    type="primary"
                    onClick={() => {
                      onClick?.('cdn_create_2');
                      setTimeout(() => {
                        document
                          .getElementById('guideNetworkList')
                          ?.scrollIntoView({ behavior: 'smooth' });
                      }, 100);
                    }}
                  >
                    <FormattedMessage id="guide.next" />
                    <ArrowRightOutlined style={{ marginLeft: 5 }} />
                  </Button>
                  {closeStepRender({ onClick })}
                </div>
              </div>
            </div>
          </div>
          <div className="u-img61">
            <GuideBox title={formatter({ id: 'guide.CdnCreate.step.title6.1' })} dir="bottomLeft">
              <div>{formatter({ id: 'guide.CdnCreate.step.content6.1' })}</div>
            </GuideBox>
          </div>
          <div className={'u-img62'}>
            <GuideBox dir="topLeft">
              <div>{formatter({ id: 'guide.CdnCreate.step.content6.2' })}</div>
            </GuideBox>
          </div>
        </>
      ) : null}
      {step === 2 ? (
        <div className={`u-img3 u-img-${locale}`}>
          <div className="u-guide-btnBox">
            <div className="u-right">
              <GuideBox
                title={formatter({ id: 'guide.CdnCreate.step.title2' })}
                dir={window.innerWidth <= 768 ? 'bottom' : 'left'}
                maxWidth={560}
                isLongLine={window.innerWidth <= 768}
              >
                <div className="c-orange">
                  <b>{formatter({ id: 'guide.CdnCreate.step.content2.1' })}</b>
                </div>
                <div>
                  {formatter({ id: 'guide.CdnCreate.step.content2.2' })}
                  <br />
                  <br />
                  {formatter({ id: 'guide.CdnCreate.step.content2.3' })}
                </div>
                <div className="c-orange">
                  <br />
                  <b>{formatter({ id: 'guide.CdnCreate.step.content2.4' })}</b>
                </div>
                <div>
                  {formatter({ id: 'guide.CdnCreate.step.content2.5' })}
                  <br />
                  <br />
                  {formatter({ id: 'guide.CdnCreate.step.content2.6' })}
                </div>
              </GuideBox>
              <div className="u-btn-box f-tr">
                <Button
                  type="primary"
                  onClick={() => {
                    onClick?.('cdn_create_3');
                  }}
                >
                  <FormattedMessage id="guide.next" />
                  <ArrowRightOutlined style={{ marginLeft: 5 }} />
                </Button>
                {closeStepRender({ onClick })}
              </div>
            </div>
            <div className="u-left">
              <img src={guideLeftImg} />
            </div>
          </div>
        </div>
      ) : null}
      {step === 3 ? (
        <div className={`u-img4 u-img-${locale}`}>
          <div className="u-guide-btnBox">
            <div className="u-right">
              <GuideBox dir="bottomLeft" maxWidth={400} isLongLine={true}>
                <div>
                  {formatter({ id: 'guide.CdnCreate.step.content3.1' })}
                  <label className="c-orange">
                    {formatter({ id: 'guide.CdnCreate.step.content3.2' })}
                  </label>
                  {formatter({ id: 'guide.CdnCreate.step.content3.3' })}
                </div>
              </GuideBox>
              <div className="u-btn-box f-tr">
                <Button
                  type="primary"
                  onClick={() => {
                    onClick?.('cdn_create_4');
                    document.getElementById('cdnCreateBtn')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <FormattedMessage id="guide.next" />
                  <ArrowRightOutlined style={{ marginLeft: 5 }} />
                </Button>
                {closeStepRender({ onClick })}
              </div>
            </div>
            <div className="u-left">
              <img src={guideLeftImg} />
            </div>
          </div>
        </div>
      ) : null}
      {step === 4 ? (
        <div className="u-img5">
          <div className="u-guide-btnBox">
            <div className="u-left">
              <img src={guideImg} />
            </div>
            <div className="u-right">
              <GuideBox dir="bottomRight" maxWidth={400}>
                <div>
                  {formatter({ id: 'guide.CdnCreate.step.content4.1' })}
                  <br />
                  {formatter({ id: 'guide.CdnCreate.step.content4.2' })}
                  <br />
                  <br />
                  {formatter({ id: 'guide.CdnCreate.step.content4.3' })}
                </div>
              </GuideBox>
              <div className="f-pl">
                <Button
                  type="primary"
                  onClick={() => {
                    onClick?.();
                    document.getElementById('guide-top')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <FormattedMessage id="guide.attempt" />
                  <ArrowRightOutlined style={{ marginLeft: 5 }} />
                </Button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
export default CdnCreate;
